import { readPublicShareRoute } from './shareRoute';

export const SHARED_ANSWER_RETURN_PARAM = 'shareReturnTo';
const OPEN_PROMPT_PARAM = 'signupPrompt';
const LOCAL_URL_BASE = 'https://palen.invalid';

function normalizeSharedAnswerReturnPath(value: string | null): string | null {
  if (!value?.startsWith('/') || value.startsWith('//') || value.includes('\\')) return null;
  if (Array.from(value).some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)) return null;

  try {
    const url = new URL(value, LOCAL_URL_BASE);
    if (url.origin !== LOCAL_URL_BASE || !readPublicShareRoute(url.pathname)) return null;
    url.searchParams.set(OPEN_PROMPT_PARAM, '1');
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function readSharedAnswerSignupReturnPath(search: string): string | null {
  return normalizeSharedAnswerReturnPath(new URLSearchParams(search).get(SHARED_ANSWER_RETURN_PARAM));
}

export function readCurrentSharedAnswerSignupReturnPath(): string | null {
  if (typeof window === 'undefined') return null;
  return normalizeSharedAnswerReturnPath(`${window.location.pathname}${window.location.search}${window.location.hash}`);
}

export function buildSharedAnswerSignupHref(href: string, returnPath: string | null): string {
  const target = normalizeSharedAnswerReturnPath(returnPath);
  if (!target) return href;
  const url = new URL(href, LOCAL_URL_BASE);
  url.searchParams.set(SHARED_ANSWER_RETURN_PARAM, target);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function shouldRestoreSharedAnswerSignupPrompt(): boolean {
  return typeof window !== 'undefined'
    && readPublicShareRoute(window.location.pathname) !== null
    && new URLSearchParams(window.location.search).get(OPEN_PROMPT_PARAM) === '1';
}

export function rememberSharedAnswerSignupPrompt(): void {
  const returnPath = readCurrentSharedAnswerSignupReturnPath();
  if (returnPath) window.history.replaceState(window.history.state, '', returnPath);
}

export function clearSharedAnswerSignupPrompt(): void {
  if (!shouldRestoreSharedAnswerSignupPrompt()) return;
  const url = new URL(window.location.href);
  url.searchParams.delete(OPEN_PROMPT_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}
